module.exports = __webpack_public_path__ + "img/portfolio-three-column.6a54796a.png";